module.exports = __webpack_public_path__ + "static/img/logo.f3381c0.png";


//////////////////
// WEBPACK FOOTER
// ./static/logo.png
// module id = 7Ogj
// module chunks = 1